import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PrivacyCms } from '../../interfaces/privacy-cms.interface';
import { lmwBaseRoutes } from "../../routing/route-locales/lmw-base-routes";

@Component({
  selector: 'lmw-base-privacy',
  templateUrl: './privacy.component.html'
})
export class PrivacyComponent implements OnInit {

  public privacyCmsData: PrivacyCms;
  public mobileBackButtonText = lmwBaseRoutes.homeLinkText;

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.privacyCmsData = this.route.snapshot.data.cmsData;
  }

}
